/**
 * Operations API client — Sprint 1
 * Wraps all /api/incidents and /api/analytics endpoints.
 */
import { authStore } from "@/lib/authStore";
import { withTenant } from "@/lib/tenantImpersonation";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

function headers() {
  const token = authStore.getAccessToken();
  return {
    "Content-Type": "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
}

async function req(method, path, body) {
  const url = withTenant(API + path);
  const res = await fetch(url, {
    method,
    headers: headers(),
    ...(body !== undefined ? { body: JSON.stringify(body) } : {}),
  });
  const text = await res.text();
  const data = text ? JSON.parse(text) : {};
  if (!res.ok) throw Object.assign(new Error(data.detail || res.statusText), { status: res.status, data });
  return data;
}

// ─── Incidents ────────────────────────────────────────────────────────────────

export const listIncidents = (params = {}) => {
  const qs = new URLSearchParams(params).toString();
  return req("GET", `/incidents${qs ? "?" + qs : ""}`);
};

export const getIncident = (id) => req("GET", `/incidents/${id}`);

export const createIncident = (body) => req("POST", "/incidents", body);

export const addEvent = (id, body) => req("POST", `/incidents/${id}/events`, body);

export const closeIncident = (id, body) => req("POST", `/incidents/${id}/close`, body);

export const promoteIncident = (id, body = {}) => req("POST", `/incidents/${id}/promote`, body);

// ─── Knowledge promotions ─────────────────────────────────────────────────────

export const getPromotionQueue = (status = "pending_review") =>
  req("GET", `/incidents/promotions/queue?status=${status}`);

export const reviewPromotion = (promotionId, body) =>
  req("POST", `/incidents/promotions/${promotionId}/review`, body);

// ─── Analytics ────────────────────────────────────────────────────────────────

export const getBaseline = () => req("GET", "/analytics/baseline");

export const getDelta = () => req("GET", "/analytics/delta");

export const getKnowledgeMetrics = () => req("GET", "/analytics/knowledge");

export const getExecutiveSummary = () => req("GET", "/analytics/executive");

export const setBaseline = (enabled_at) =>
  req("POST", "/analytics/baseline/set", { enabled_at });
